import SingleInvoice from '../pages/admin/finance/Invoices/SingleInvoice'
import UnpaidInvoices from '../pages/admin/finance/UnpaidInvoices'
import Invoices from '../pages/admin/finance/Invoices/Invoices'
import Quotes from '../pages/admin/finance/Quotes/Quotes'
import FinanceCentre from '../pages/admin/finance/FinanceCentre'

export default [
  { path: '/finance', element: <FinanceCentre />, title: 'Finance' },
  { path: '/finance/quotes', element: <Quotes />, title: 'Quotes' },
  { path: '/unpaid-invoices', element: <UnpaidInvoices />, title: 'Unpaid Invoices' },
  { path: '/invoices', element: <Invoices />, title: 'Invoices' },
  { path: '/invoices/:invoiceID', element: <SingleInvoice /> },
]
